<template>
  <div class="mt-4">
    <p class="mb-3 uppercase xs-text xs-content">
      Your personal title should be no longer than 20 character in length.
    </p>
    <input
      class="w-100"
      type="text"
      name="frame.personalTitle.text"
      placeholder="Enter your text"
      v-model="titleText"
    />
    <p class="xs-text xs-content strlen-wrapper">Title length: {{ strlen }}</p>
  </div>
</template>

<script>
export default {
  name: "frame-frame-title-text",
  data() {
    return {
      strlen: 0
    };
  },
  props: ["results"],
  computed: {
    titleText: {
      get: function () {
        return this.results.frame.title.text;
      },
      set: function (e) {
        this.$emit("update-title-text", e);
      },
    },
  },
  watch: {
    titleText: function(val) {
      this.strlen = val.length;
      if (val.length>20) {
        this.titleText = this.titleText.substr(0, 20);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="text"] {
  padding: 8px 12px;
  font-size: 12px;
}
.strlen-wrapper {
  margin-top: 8px;
}
</style>